import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { sizes, cmThemes, cmModes } from "../../../enums";
import { whitelistStyles } from "../../core/hoc"; //prevents weird artifact on end of line string for new lines

function normalizeLineEndings(str) {
  if (!str) return str;
  return str.replace(/\r\n|\r/g, '\n');
}

var CKCodeMirror = createComponent({
  displayName: 'CodeMirror',
  propTypes: {
    fontSize: PropTypes.oneOf(sizes.ALL),
    codeMirrorInstance: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onScroll: PropTypes.func,
    options: PropTypes.shape({
      lineNumbers: PropTypes.bool,
      mode: PropTypes.oneOf(cmModes.ALL),
      theme: PropTypes.oneOf(cmThemes.ALL),
      lineWrapping: PropTypes.bool
    }),
    id: PropTypes.string,
    value: PropTypes.string,
    preserveScrollPosition: PropTypes.bool
  },
  defaultProps: {
    fontSize: sizes.X3,
    //in the next iteration this will be the fallback in case no codemirror was provided
    //codeMirrorInstance    : CMCodeMirror,
    onChange: undefined,
    onFocus: undefined,
    onBlur: undefined,
    onScroll: undefined,
    options: {},
    id: '',
    value: '',
    preserveScrollPosition: false
  },
  contextTypes: {},
  refs: 'textareaRef',
  handlers: {
    handleChange: function handleChange(props) {
      return function (codeMirror, change) {
        if (!!props.onChange && change.origin !== 'setValue') {
          props.onChange(change, {
            id: props.id,
            value: normalizeLineEndings(codeMirror.getValue())
          });
        }
      };
    },
    handleFocus: function handleFocus(props) {
      return function (codeMirror, ev) {
        !!props.codeMirror && props.codeMirror.focus(true);
        !!props.onFocus && props.onFocus(ev, {
          id: props.id,
          value: true
        });
      };
    },
    handleBlur: function handleBlur(props) {
      return function (codeMirror, ev) {
        !!props.codeMirror && props.codeMirror.focus(false);
        !!props.onBlur && props.onBlur(ev, {
          id: props.id,
          value: false
        });
      };
    },
    handleScroll: function handleScroll(props) {
      return function (codeMirror, ev) {
        props.onScroll && props.onScroll(ev, {
          id: props.id,
          value: codeMirror.getScrollInfo()
        });
      };
    }
  },
  lifecycles: {
    componentDidMount: function componentDidMount() {
      //Getting the dummy text area we have created in render using React findDOMNode
      var textareaNode = this.props.refs.textareaRef; //gettin the CodeMirror instance, we either use the props provided one or we use our own fallback instance

      var codeMirrorInstance = this.props.codeMirrorInstance; //we create our codemirror object using the CodeMirror class and the generated textarea

      this.codeMirror = codeMirrorInstance.fromTextArea(textareaNode, this.props.options); //need to check if the onChange returns the value for the text

      this.codeMirror.on('change', this.props.handleChange);
      this.codeMirror.on('focus', this.props.handleFocus);
      this.codeMirror.on('blur', this.props.handleBlur);
      this.codeMirror.on('scroll', this.props.handleScroll); //after we have created our CodeMirror object we set the value to be the one passed in through value, or fallback
      //to an empty string

      this.codeMirror.setValue(this.props.value);
      this.codeMirror.refresh();
    },
    //we need to remove the CodeMirror instance when we unmount the object in order to eliminate any memory leaks
    componentWillUnmount: function componentWillUnmount() {
      //is there a lighter-weight way to remove the cm instance?
      //source found at: http://stackoverflow.com/questions/18828658/how-to-kill-a-codemirror-instance
      if (this.codeMirror) {
        this.codeMirror.toTextArea();
      }
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.codeMirror && nextProps.value !== undefined && normalizeLineEndings(this.codeMirror.getValue()) !== normalizeLineEndings(nextProps.value)) {
        if (this.props.preserveScrollPosition) {
          var prevScrollPosition = this.codeMirror.getScrollInfo();
          this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);
        }

        this.codeMirror.setValue(nextProps.value);
      }

      for (var optionName in nextProps.options) {
        if (nextProps.options.hasOwnProperty(optionName)) {
          this.codeMirror.setOption(optionName, nextProps.options[optionName]);
        }
      }
    }
  },
  render: function render(props) {
    var editorClassName = classnames('ck', 'codemirror', props.fontSize); //setting up a simple textarea that CodeMirror will hook onto

    return /*#__PURE__*/React.createElement("div", {
      className: editorClassName,
      style: props.style
    }, /*#__PURE__*/React.createElement("textarea", {
      ref: props.setTextareaRef,
      autoComplete: "off"
    }));
  }
});
export default whitelistStyles()(CKCodeMirror);
//# sourceMappingURL=codemirror.js.map